import { PROFILER_IMAGES } from '../Common/constants';
import {
  IndustryEnum,
  BCMSubIndustryEnum,
  BCMTurnoverEnum,
  BCMMonthlyTurnoverRange_ALL,
  BCMMonthlyTurnoverRangeR1,
  FMCGSubIndustryEnum,
  FMCGBrandNumbersEnum,
  FMCGTurnoverEnum,
  FMCGStoreTypeEnum,
  YesNoEnum,
  PreferredLanguageEnum,
  RecHolidayTypeEnum,
  MaritalStatusEnum,
  MaritalSpouseHelpEnum
} from './Profiler_enum';
import { ProfilerQuestionID } from './QuestionEnum';


export const QUESTIONS = [
  {
    id: ProfilerQuestionID.INDUSTRY,
    question: "What is your industry?",
    options: [
      {
        label: IndustryEnum.FMCG,
        value: IndustryEnum.FMCG,
        image:
          "https://d2djimvzddgguw.cloudfront.net/humbee_profiler/images/basket.png",
      },
      {
        label: IndustryEnum.BCM,
        value: IndustryEnum.BCM,
        image:
          "https://d2djimvzddgguw.cloudfront.net/humbee_profiler/images/shilpkar.png",
      },
    ],
  },
  {
    id: ProfilerQuestionID.BCM_SUB_INDUSTRY,
    question: "Which sub-industry do you work in?",
    fieldType: "checkbox",
    questionTitle: "(Select 1 or more)",
    options: [
      { label: BCMSubIndustryEnum.CEMENT, value: BCMSubIndustryEnum.CEMENT },
      { label: BCMSubIndustryEnum.STEEL, value: BCMSubIndustryEnum.STEEL },
      {
        label: BCMSubIndustryEnum.PAINT_AND_HARDWARE,
        value: BCMSubIndustryEnum.PAINT_AND_HARDWARE,
      },
      {
        label: BCMSubIndustryEnum.TILES_AND_ADHESIVE,
        value: BCMSubIndustryEnum.TILES_AND_ADHESIVE,
      },
      { label: BCMSubIndustryEnum.PLYWOOD, value: BCMSubIndustryEnum.PLYWOOD },
      {
        label: BCMSubIndustryEnum.ELECTRICALS_SUPPLIERS,
        value: BCMSubIndustryEnum.ELECTRICALS_SUPPLIERS,
      },
    ],
  },
  {
    id: ProfilerQuestionID.BCM_BRAND_NAME,
    fieldType: "tags",
    question: "Which brands do you work with?",
    questionTitle: "(Add 1 or more)",
  },
  {
    id: ProfilerQuestionID.BCM_TURNOVER,
    fieldType: "select",
    subtitle: "This helps us give you more Social Security Benefits",
    question: "What’s your monthly turnover?",
    options: Object.entries(BCMTurnoverEnum).map(([key, label]) => ({
      label,
      value: label,
    })),
    image:
      "https://d2djimvzddgguw.cloudfront.net/humbee_profiler/images/turn_over_bcm.png",
  },

  // FMCG FLOW
  {
    id: ProfilerQuestionID.FMCG_SUB_INDUSTRY,
    fieldType: "checkbox",
    question: "Which sub-industry do you work in?",
    questionTitle: "(Select 1 or more)",
    options: [
      {
        label: FMCGSubIndustryEnum.PACKAGED_GOODS,
        value: FMCGSubIndustryEnum.PACKAGED_GOODS,
      },
      {
        label: FMCGSubIndustryEnum.FROZEN_GOODS,
        value: FMCGSubIndustryEnum.FROZEN_GOODS,
      },
      {
        label: FMCGSubIndustryEnum.BEVERAGES,
        value: FMCGSubIndustryEnum.BEVERAGES,
      },
      {
        label: FMCGSubIndustryEnum.BEAUTY_AND_PERSONAL_CARE,
        value: FMCGSubIndustryEnum.BEAUTY_AND_PERSONAL_CARE,
      },
      {
        label: FMCGSubIndustryEnum.DAIRY_PRODUCTS,
        value: FMCGSubIndustryEnum.DAIRY_PRODUCTS,
      },
      {
        label: FMCGSubIndustryEnum.BAKERY_PRODUCTS,
        value: FMCGSubIndustryEnum.BAKERY_PRODUCTS,
      },
    ],
  },
  {
    id: ProfilerQuestionID.FMCG_BRAND_NUMBERS,
    fieldType: "radio",
    question: "How many brands do you deal in?",
    options: [
      {
        label: FMCGBrandNumbersEnum.BELOW_10,
        value: FMCGBrandNumbersEnum.BELOW_10,
      },
      {
        label: FMCGBrandNumbersEnum.BETWEEN_10_AND_25,
        value: FMCGBrandNumbersEnum.BETWEEN_10_AND_25,
      },
      {
        label: FMCGBrandNumbersEnum.BETWEEN_25_AND_50,
        value: FMCGBrandNumbersEnum.BETWEEN_25_AND_50,
      },
      {
        label: FMCGBrandNumbersEnum.ABOVE_50,
        value: FMCGBrandNumbersEnum.ABOVE_50,
      },
    ],
  },
  {
    id: ProfilerQuestionID.FMCG_TURNOVER,
    subtitle: "This helps us give you more Social Security Benefits",
    fieldType: "select",
    question: "What’s your monthly turnover?",
    options: [
      {
        label: FMCGTurnoverEnum.BELOW_5_LACS,
        value: FMCGTurnoverEnum.BELOW_5_LACS,
      },
      {
        label: FMCGTurnoverEnum.BETWEEN_5_AND_25_LACS,
        value: FMCGTurnoverEnum.BETWEEN_5_AND_25_LACS,
      },
      {
        label: FMCGTurnoverEnum.BETWEEN_25_AND_100_LACS,
        value: FMCGTurnoverEnum.BETWEEN_25_AND_100_LACS,
      },
      {
        label: FMCGTurnoverEnum.ABOVE_100_LACS,
        value: FMCGTurnoverEnum.ABOVE_100_LACS,
      },
    ],
    Subtitle: "This helps us give you more Social Security Benefits",
    image:
      "https://d2djimvzddgguw.cloudfront.net/humbee_profiler/images/turn_over_fmcg.png",
  },
  {
    id: ProfilerQuestionID.FMCG_STORE_TYPE,
    fieldType: "select",
    question: "What’s your store type?",
    options: [
      {
        label: FMCGStoreTypeEnum.SELF_SERVICE_STORE,
        value: FMCGStoreTypeEnum.SELF_SERVICE_STORE,
      },
      {
        label: FMCGStoreTypeEnum.KIRANA_STORE,
        value: FMCGStoreTypeEnum.KIRANA_STORE,
      },
      {
        label: FMCGStoreTypeEnum.WHOLESALERS,
        value: FMCGStoreTypeEnum.WHOLESALERS,
      },
      {
        label: FMCGStoreTypeEnum.BAKERY_STORE,
        value: FMCGStoreTypeEnum.BAKERY_STORE,
      },
      {
        label: FMCGStoreTypeEnum.MASALA_STORE,
        value: FMCGStoreTypeEnum.MASALA_STORE,
      },
      {
        label: FMCGStoreTypeEnum.CHEMIST_STORE,
        value: FMCGStoreTypeEnum.CHEMIST_STORE,
      },
    ],
    subtitle: "This helps us give you more Social Security Benefits",
    image:
      "https://d2djimvzddgguw.cloudfront.net/humbee_profiler/images/store_type.png",
  },
  {
    id: ProfilerQuestionID.FMCG_FROZEN_FOODS,
    fieldType: "radio",
    question: "Do you keep frozen food items?",
    options: [
      { label: YesNoEnum.YES, value: true },
      { label: YesNoEnum.NO, value: false },
    ],
    subtitle: "This helps us give you more Social Security Benefits",
    image:
      "https://d2djimvzddgguw.cloudfront.net/humbee_profiler/images/fridge.png",
  },

  // INDEPENDENT QUESTIONS
  {
    id: ProfilerQuestionID.NEXT_GEN,
    fieldType: "select",
    question: "Would your kids or next generation take over your business?",
    options: [
      { label: YesNoEnum.YES, value: true },
      { label: YesNoEnum.NO, value: false },
    ],
    subtitle: "We’d love to serve your family too! ",
    image:
      "https://d2djimvzddgguw.cloudfront.net/humbee_profiler/images/next-gen.png",
  },
  {
    id: ProfilerQuestionID.INSURANCE_INTEREST,
    fieldType: "radio",
    question: "Are you interested in insurance?",
    options: [
      { label: YesNoEnum.YES, value: true },
      { label: YesNoEnum.NO, value: false },
    ],
  },
  {
    id: ProfilerQuestionID.PREFERRED_LANGUAGE,
    fieldType: "preferred_language",
    question: "What is your preferred language of communication?",
    getOptions: (apiData) => {
      if (!apiData || !apiData.preferred || !apiData.others)
        return { preferred: [], others: [] };
      return {
        preferred: apiData.preferred.map((lang) => ({
          label: lang,
          value: lang,
        })),
        others: apiData.others.map((lang) => ({ label: lang, value: lang })),
      };
    },
  },
  {
    id: ProfilerQuestionID.PREFERRED_HOLIDAY_DESTINATION,
    category: "recreational",
    fieldType: "select",
    question: "Where would you like to go for holiday in India?",
    placeholder: "Select location",
    options: [
      { label: RecHolidayTypeEnum.DESERT, value: RecHolidayTypeEnum.DESERT },
      { label: RecHolidayTypeEnum.TEMPLES, value: RecHolidayTypeEnum.TEMPLES },
      {
        label: RecHolidayTypeEnum.MOUNTAINS,
        value: RecHolidayTypeEnum.MOUNTAINS,
      },
      {
        label: RecHolidayTypeEnum.ADVENTURE,
        value: RecHolidayTypeEnum.ADVENTURE,
      },
      {
        label: RecHolidayTypeEnum.FOOD_NIGHTLIFE,
        value: RecHolidayTypeEnum.FOOD_NIGHTLIFE,
      },
      { label: RecHolidayTypeEnum.BEACH, value: RecHolidayTypeEnum.BEACH },
    ],
  },
  {
    id: ProfilerQuestionID.PREFERRED_DOMESTIC_DESTINATION,
    fieldType: "textarea",
    category: "recreational",
    question: "Which holiday destination you like the most in India?",
    placeholder: "Type here",
  },
  {
    id: ProfilerQuestionID.PREFERRED_INTERNATIONAL_DESTINATION,
    fieldType: "textarea",
    category: "recreational",
    question: "Which foreign destination would you like to visit?",
    placeholder: "Type here",
  },

  {
    id: ProfilerQuestionID.MARITAL_STATUS,
    fieldType: "select",
    category: "marital",
    question: "What's your marital status?",
    options: [
      {
        label: MaritalStatusEnum.MARRIED,
        value: MaritalStatusEnum.MARRIED,
        icon: PROFILER_IMAGES.married,
      },
      {
        label: MaritalStatusEnum.SINGLE,
        value: MaritalStatusEnum.SINGLE,
        icon: PROFILER_IMAGES.single,
      },
      {
        label: MaritalStatusEnum.PREFER_NOT_TO_SAY,
        value: MaritalStatusEnum.PREFER_NOT_TO_SAY,
      },
    ],
  },
  {
    id: ProfilerQuestionID.MARRIAGE_ANNIVERSARY,
    fieldType: "date",
    category: "marital",
    question: "When is your wedding anniversary?",
  },
  {
    id: ProfilerQuestionID.SPOUSE_BUSINESS_INVOLVEMENT,
    fieldType: "select",
    category: "marital",
    question: "Is your spouse helping you in business?",
    options: [
      {
        label: MaritalSpouseHelpEnum.HOME_MAKER,
        value: MaritalSpouseHelpEnum.HOME_MAKER,
      },
      {
        label: MaritalSpouseHelpEnum.HELPING_IN_BUSINESS,
        value: MaritalSpouseHelpEnum.HELPING_IN_BUSINESS,
      },
      {
        label: MaritalSpouseHelpEnum.WORKING_PROFESSIONAL,
        value: MaritalSpouseHelpEnum.WORKING_PROFESSIONAL,
      },
    ],
  },
  {
    id: ProfilerQuestionID.KIDS_COUNT,
    fieldType: "number",
    category: "kids",
    question: "How many kids do you have?",
  },
  {
    id: ProfilerQuestionID.KIDS_EDUCATION_COUNT,
    fieldType: "number",
    category: "kids",
    question: "How many of your kids currently study in 10th, 12th or college?",
  },
];
export const CATEGORY_CONFIG = {
  recreational: {
    title: 'Recreational Details',
    image: 'https://d2djimvzddgguw.cloudfront.net/humbee_profiler/images/taj_mahal.png',
    subtitle: 'This would help us to decide where to take you for annual trip.',
  },
  marital: {
    title: 'Marital Details',
    image: 'https://d2djimvzddgguw.cloudfront.net/humbee_profiler/images/ring.png',
    subtitle: 'We may use this to send you a small surprise 😊',
  },
  kids: {
    title: 'Kids',
    image: 'https://d2djimvzddgguw.cloudfront.net/humbee_profiler/images/adhyayan.png',
    subtitle: 'Scholarship for young bright minds!',
  },
};

export function getCategoryConfig(category) {
  return CATEGORY_CONFIG[category] || null;
}

export function getQuestionConfig(id) {
  return QUESTIONS.find(q => q.id === id);
}
